import { useEffect, useState } from "react";

/**
 * Mantem estado de loading por um tempo minimo pra animacao nao flashar.
 * Quando isLoading vira false, aguarda `minMs` antes de devolver false.
 */
export function useMinimumLoading(isLoading: boolean, minMs = 500): boolean {
  const [show, setShow] = useState(isLoading);

  useEffect(() => {
    if (isLoading) {
      setShow(true);
      return;
    }
    const t = window.setTimeout(() => setShow(false), minMs);
    return () => window.clearTimeout(t);
  }, [isLoading, minMs]);

  return show;
}
